import React, {
  useState,
  useEffect,
  memo,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useSelector } from "react-redux";
import { authLoginSelector } from "../../../features/auth/authLoginSlice";
import { IsDashBoardLawfirmSelected } from "../../../common/utils";
// const monerisProfileId = process.env.REACT_APP_PROFILE_ID_MONERIS_QA;
// const monerisProfileId = process.env.REACT_APP_PROFILE_ID_MONERIS_DEV;
const monerisProfileId = "htZXPEPDT24R73U";

const PaymentToken = forwardRef(
  (
    {
      id = "monerisFrame",
      setTokenKey,
      firmIDAndName,
      billing,
      setCCDailog,
      setCreditCardRequest,
      values,
      billingValues,
      index,
      setShowPaymentMethodForm,
      defaultMethod,
      setAltPaymentReq,
      setEftPaymentReq,
      setChequePaymentReq,
      invoices,
      showCClabel=true,
      watch,
      ManageBillingLawyer,
      DashboardLawfirm,
      ManageBillingLawyerName,
      currentLanguage
    },
    ref
  ) => {
    const [error, setError] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const { userLogin } = useSelector(authLoginSelector);


    const inputCSS =
      '&css_textbox=margin-bottom: 10px;border-radius: 4px; display: inline; margin-right: 20px; margin-left: 10px; border: 1px solid rgb(206, 212, 218);font-size: 0.875rem;width: auto;padding: 10px 12px;transition: border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;font-family: "Roboto", "Helvetica", "Arial", sans-serif;&css_textbox:hover=display: inline;';
    const exp_label = "&exp_label=Expiry Date (MMYY)";

    const iQuery =
      "id=" +
      monerisProfileId +
      "&display_labels=2&pmmsg=true" +
      inputCSS +
      "&css_textbox_pan=width:280px;display:inline;margin-top:0px;margin-left:9px;height:41px;&enable_exp=1&css_textbox_exp=width:90px;margin-left:-11px;height:41px;display:inline;&enable_cvd=1&css_textbox_cvd=width:90px;display:inline;margin-left:-11px;height:41px;" +
      exp_label;

    const doMonerisSubmit = () => {
      var monFrameRef = document.getElementById(id).contentWindow;
      console.log(monFrameRef);
      monFrameRef.postMessage("tokenize", process.env.REACT_APP_HOSTED_URL);
      //change link according to table above
      return false;
    };

    // const respMsg = React.useCallback((e) => {
    //   // Check if e.data is a string, and if not, convert it to a JSON string
    //   setError("");
    //   setErrorMessage("");
    //   let dataString = e.data;
    //   if (typeof dataString !== "string") {
    //     dataString = JSON.stringify(dataString);
    //   }

    //   try {
    //     var respData = JSON.parse(dataString);
    //     if (typeof respData.dataKey !== "undefined") {
    //       setTokenKey(respData.dataKey, respData?.bin);
    //     } else {
    //       // $("[id*='hdnHostedTokenDataKey'").val('');
    //     }
    //     if (respData.errorMessage !== null) {
    //       // $("[id*='hdnHostedTokenResponseCode']").val(respData.responseCode);

    //       if (typeof respData.dataKey !== "undefined") {
    //         //  setValue(respData.dataKey);
    //         // setTokenKey(respData.dataKey);
    //         setTokenKey(respData.dataKey, respData?.bin);
    //       } else {
    //         // $("[id*='hdnHostedTokenDataKey'").val('');
    //       }

    //       setErrorMessage(respData.errorMessage);
    //       setCCDailog(false);
    //       if (respData?.responseCode?.length == 3) {
    //         if (
    //           respData.responseCode[0] == "943" ||
    //           respData.responseCode[1] == "944" ||
    //           respData.responseCode[2] == "945"
    //         ) {
    //           setError(
    //             "Invalid Data-Card data,Expiration date,&CVD data. Error code: " +
    //               respData.responseCode
    //           );
    //           return;
    //         }
    //       }

    //       if (respData.responseCode == "940") {
    //         //Invalid profile id(on tokenization request)
    //         setError(
    //           "Please contact technical support for assistance. Error code: " +
    //             respData.responseCode
    //         );
    //         return;
    //       } else if (respData.responseCode == "941") {
    //         //"Error generating token"
    //         setError(
    //           "Please contact technical support for assistance. Error code: " +
    //             respData.responseCode
    //         );
    //         return;
    //       } else if (respData.responseCode == "942") {
    //         //"Invalid Profile ID, or source URL"
    //         setError(
    //           "Please contact technical support for assistance. Error code: " +
    //             respData.responseCode
    //         );
    //         return;
    //       } else if (respData.responseCode == "943") {
    //         //"Card data is invalid(not numeric, fails mod10, we will remove spaces)"
    //         setError(
    //           "Card data is invalid. Plese check your card details. Error code: " +
    //             respData.responseCode
    //         );
    //         return;
    //       } else if (respData.responseCode == "944") {
    //         // Invalid expiration date(mmyy, must be current month or in the future)
    //         //$("[id*='monerisResponse'").html(respData.errorMessage);
    //         //$("[id*='monerisResponse'").css('color', 'red');
    //         setError(
    //           "Invalid expiration date(mmyy, must be current month or in the future). Please check it. Error code: " +
    //             respData.responseCode
    //         );
    //         return;
    //       } else if (respData.responseCode == "945") {
    //         //"Invalid CVD data(not 3 - 4 digits)"
    //         //'invalid credentials'
    //         if (respData.errorMessage == "invalid credentials") {
    //           return;
    //         }
    //         setError(
    //           "Invalid CVD data(not 3 - 4 digits). Please check it. Error code: " +
    //             respData.responseCode
    //         );
    //         return;
    //       } else if (typeof respData.dataKey !== "undefined") {
    //         let request = {
    //           UserID: userLogin?.userId,
    //           FirmName: firmIDAndName?.firmName,
    //           LawyerName: userLogin?.isLawyer ? userLogin.loginName : "",
    //           PrefferredBillingType: billing,
    //           LawyerID: firmIDAndName?.hasFirmBilling
    //             ? 0
    //             : userLogin?.isLawyer
    //             ? userLogin?.userId
    //             : billingValues[`assistantsLawyer`],
    //           FirmID: firmIDAndName?.firmID,
    //           DealType: values?.DealType
    //             ? values?.DealType
    //             : values?.dealType
    //             ? 3
    //             : null,
    //           HostedTempToken: respData?.dataKey,
    //           IsEditOutstandingInvoiceEmail: false,
    //           RecipientEmail: "",
    //           ChangeNote: "",
    //           PaymentMethod: "Credit Card Payment",
    //           SelfManaged: 1,
    //           Statement: 0,
    //           Retainer: 0,
    //           CreditLimit: 0.0,
    //           BillingType: "",
    //           BillingFrequency: "",
    //           StatementFrequency: "",
    //           PaymentFrequency: "",
    //           UserName: userLogin.loginName,
    //           Acknowledgement: true,
    //           FirmSelected: billing === "firm" ? true : false,
    //           isAllDealType: values?.dealType || values?.DealType,
    //         };
    //         
    //         if (
    //           respData?.dataKey !== null &&
    //           respData?.dataKey !== "undefined" &&
    //           respData?.dataKey !== ""
    //         ) {
    //           setCCDailog(true);
    //           setCreditCardRequest(request);
    //         }
    //       } else {
    //         respData?.errorMessage &&
    //           setError(
    //             "Please contact technical support for assistance. Error code: datakey not generated "
    //           );
    //         return;
    //       }
    //     }
    //     console.log(respData);
    //   } catch (error) {
    //     console.error("Error parsing JSON data:", error);
    //   }
    // }, []);

    //watch(respMsg);
    const respMsg = (e)  => {
      // Check if e.data is a string, and if not, convert it to a JSON string

      
      setError("");
      setErrorMessage("");
      let dataString = e.data;
      if (typeof dataString !== "string") {
        dataString = JSON.stringify(dataString);
      }

      try {
        var respData = JSON.parse(dataString);
        if (typeof respData.dataKey !== "undefined") {
          setTokenKey(respData.dataKey, respData?.bin);
        } else {
          // $("[id*='hdnHostedTokenDataKey'").val('');
        }
        if (respData.errorMessage !== null) {
          // $("[id*='hdnHostedTokenResponseCode']").val(respData.responseCode);

          if (typeof respData.dataKey !== "undefined") {
            //  setValue(respData.dataKey);
            // setTokenKey(respData.dataKey);
            setTokenKey(respData.dataKey, respData?.bin);
          } else {
            // $("[id*='hdnHostedTokenDataKey'").val('');
          }

          setErrorMessage(respData.errorMessage);
          
         // setCCDailog(false);
          if (respData?.responseCode?.length == 3) {
            if (
              respData.responseCode[0] == "943" ||
              respData.responseCode[1] == "944" ||
              respData.responseCode[2] == "945"
            ) {
              setError(
                "Invalid Data-Card data,Expiration date,&CVD data. Error code: " +
                  respData.responseCode
              );
              return;
            }
          }

          if (respData.responseCode == "940") {
            //Invalid profile id(on tokenization request)
            setError(
              "Please contact technical support for assistance. Error code: " +
                respData.responseCode
            );
            return;
          } else if (respData.responseCode == "941") {
            //"Error generating token"
            setError(
              "Please contact technical support for assistance. Error code: " +
                respData.responseCode
            );
            return;
          } else if (respData.responseCode == "942") {
            //"Invalid Profile ID, or source URL"
            setError(
              "Please contact technical support for assistance. Error code: " +
                respData.responseCode
            );
            return;
          } else if (respData.responseCode == "943") {
            //"Card data is invalid(not numeric, fails mod10, we will remove spaces)"
            setError(
              "Card data is invalid. Plese check your card details. Error code: " +
                respData.responseCode
            );
            return;
          } else if (respData.responseCode == "944") {
            // Invalid expiration date(mmyy, must be current month or in the future)
            //$("[id*='monerisResponse'").html(respData.errorMessage);
            //$("[id*='monerisResponse'").css('color', 'red');
            setError(
              "Invalid expiration date(mmyy, must be current month or in the future). Please check it. Error code: " +
                respData.responseCode
            );
            return;
          } else if (respData.responseCode == "945") {
            //"Invalid CVD data(not 3 - 4 digits)"
            //'invalid credentials'
            if (respData.errorMessage == "invalid credentials") {
              return;
            }
            setError(
              "Invalid CVD data(not 3 - 4 digits). Please check it. Error code: " +
                respData.responseCode
            );
            return;
          } else if (typeof respData.dataKey !== "undefined") {
           setCCDailog(true); 
            let request = {
              UserID: userLogin?.userId,
              FirmName: IsDashBoardLawfirmSelected(DashboardLawfirm)?( DashboardLawfirm?.FirmName): firmIDAndName?.firmName,
              LawyerName: IsDashBoardLawfirmSelected(DashboardLawfirm)? ManageBillingLawyerName:(userLogin?.isLawyer ? userLogin.loginName : ""),
              PrefferredBillingType: billing,
              LawyerID: IsDashBoardLawfirmSelected(DashboardLawfirm) ?(DashboardLawfirm?.HasFirmBilling?0:ManageBillingLawyer):(firmIDAndName?.hasFirmBilling
                ? 0
                : userLogin?.isLawyer
                ? userLogin?.userId
                : billingValues[`assistantsLawyer`]),
              FirmID: IsDashBoardLawfirmSelected(DashboardLawfirm)?(DashboardLawfirm?.FirmID):(firmIDAndName?.firmID),
              DealType: values?.DealType
                ? values?.DealType
                : values?.dealType
                ? 3
                : null,
              HostedTempToken: respData?.dataKey,
              IsEditOutstandingInvoiceEmail: false,
              RecipientEmail: "",
              ChangeNote: "",
              PaymentMethod: "Credit Card Payment",
              SelfManaged: 1,
              Statement: 0,
              Retainer: 0,
              CreditLimit: 0.0,
              BillingType: "",
              BillingFrequency: "",
              StatementFrequency: "",
              PaymentFrequency: "",
              UserName: userLogin.loginName,
              Acknowledgement: true,
              FirmSelected: billing === "firm" ? true : false,
              isAllDealType: values?.dealType || values?.DealType,
            };
            
            if (
              respData?.dataKey !== null &&
              respData?.dataKey !== "undefined" &&
              respData?.dataKey !== ""
            ) {
              setCCDailog(true);
              setCreditCardRequest(request);
            }
          } else {
            respData?.errorMessage &&
              setError(
                "Please contact technical support for assistance. Error code: datakey not generated "
              );
            return;
          }
        }
        console.log(respData);
      } catch (error) {
        console.error("Error parsing JSON data:", error);
      }
    }
    useEffect(() => {

      window.addEventListener('message', respMsg);
  
      // Cleanup the event listener on component unmount
      return () => {
        window.removeEventListener('message', respMsg);
      };
    }, [respMsg]);

    // useEffect(() => {
    //   window.addEventListener("message", respMsg);
    //   return () => window.removeEventListener("message", respMsg);
    // }, [respMsg]);

    useImperativeHandle(ref, () => ({
      submitdata(idForm) {
        if (idForm === id) {
          doMonerisSubmit();
        }
      },
    }));
    return (
      <div className="flex flex-col mt-[10px]">
        <div
          id="monerisResponse"
          className="flex flex-row"
          style={{ height: "40px" }}
        >
          {!invoices && showCClabel &&(
            <div className="!w-[130px] input-container relative">
              <p className="font-semibold">Credit Card {index + 1}</p>
            </div>
          )}
          <div style={currentLanguage == "fr" ? {marginTop: 30} : {}}>
          <iframe
            title="title"
            id={id}
            src={`https://esqa.moneris.com/HPPtoken/index.php?${iQuery}`}
            frameBorder="0"
            height="100"
            width={790}
          /></div>
          {invoices && (
            <div
              className="flex justify-end w-[600px]"
              style={{ marginLeft: "-145px" }}
            >
              <button
                onClick={() => {
                  setShowPaymentMethodForm(false);
                }}
                className="break-keep focus-visible:bg-[#ECECEC] h-[20px] py-[9px] rounded-sm text-[#595959] text-center w-[80px]"
              >
                Cancel
              </button>
              <button
                //onClick={() => isValid ? setCCDailog(true) : trigger()}
                onClick={() => {
                  ref.current && ref.current.submitdata(`monerisFrame1`);
                  if (error === "") {
                    setShowPaymentMethodForm(false);
                    defaultMethod.includes("EFT") && setEftPaymentReq(false);
                    defaultMethod.includes("Cheque") &&
                      setChequePaymentReq(false);
                    setAltPaymentReq(false);
                  }
                }}
                // disabled={fields.length === 0}
                className="btn__primary h-[40px] px-[16px] py-[9px] w-[68px]"
              >
                Save
              </button>
            </div>
          )}
        </div>
        <div className="flex flex-row">
          {/* {errorMessage && (
            <span className="font-semibold text-secondary-red">
              {errorMessage}.{" "}
            </span>
          )} */}
          {error && (
            <span className="font-semibold text-secondary-red mt-8">{error}</span>
          )}
        </div>
      </div>
    );
  }
);

export default memo(PaymentToken);
